export var infoBox = function infoBox(theme) {
  return {
    backgroundColor: theme.gray50,
    padding: '1.5em',
    borderRadius: 8,
    marginBottom: '1em',
    '& > p': {
      marginBottom: '0.8em'
    }
  };
};
export var infoBoxRed = function infoBoxRed(theme) {
  return {
    backgroundColor: theme.errorLight,
    padding: '1.5em',
    borderRadius: 8,
    marginBottom: '1em'
  };
};